import {
  getBalanceAccounts,
  getLedgerExchange,
  getLedgerExchanges,
  editLedgerExchange,
  getUsersSuggest,
  getLedgerValutes,
  getBinanceRate,
  addLedgerExchange
} from "@/api";

import exchangeTemplates from "./ledgerExchangeAssets/exchangeTemplates";
import sources from "./ledgerExchangeAssets/sources";
import validation from "./ledgerExchangeAssets/validation";
//
const transactionTemplate = {
  valute: "",
  amount: 0,
  direction: "in",
  balanceAccount: "",
  counted: false,
  hasComission: false,
  suspended: false
};
export default {
  namespaced: true,

  state: {
    dateStart: new Date(),
    dateEnd: null,
    userName: "",
    isDeposit: false,
    isCorrection: false,
    isOpex: false,
    isInternal: false,
    comment: "",
    level: 1,
    sourceType: "",
    sourceChannel: "",
    transactions: [],
    loading: false
  }

  // mutations: {
  //   setLedgerExchanges(state, ledgerExchanges) {
  //     state.ledgerExchanges = ledgerExchanges;
  //   },
  //   setPage(state, page) {
  //     state.page = page;
  //   },
  //   setSort(state, sort) {
  //     state.sort = sort;
  //   },
  //   setLimit(state, limit) {
  //     state.limit = limit;
  //   },
  //   setIsFiltered(state, isFiltered) {
  //     state.isFiltered = isFiltered;
  //   },
  //   setSearchString(state, searchString) {
  //     state.searchString = searchString;
  //   },
  //   setCreator(state, creator) {
  //     state.creator = creator;
  //   },
  //   setQueryType(state, queryType) {
  //     state.queryType = queryType;
  //   },
  //   setLoading(state, loading) {
  //     state.loading = loading;
  //   }
  // },

  // actions: {
  //   async getLedgerExchanges(store) {
  //     store.commit("setLoading", true);
  //     const queryTemplate = store.state.queryTemplates.find(
  //       template => template.type === store.state.queryType
  //     );
  //     // $or: [{comment: {$regex:".*ec.*", $options:"i"}}, {_id: {$regex:".*ec.*", $options:"i"}}]
  //     const queryBuilded = queryTemplate ? queryTemplate.query : {};
  //     const queryForSearch = await store.dispatch("searchQueryBuilder");
  //     // console.log(queryForSearch);
  //     const resp = await getLedgerExchanges({
  //       page: store.state.page,
  //       limit: store.state.limit,
  //       sort: store.state.sort,
  //       query: { $and: [queryBuilded, queryForSearch] }
  //     });
  //     if (resp.data.status) {
  //       store.commit("setLedgerExchanges", resp.data.result);
  //       store.commit("setLoading", false);
  //       return resp.data.result;
  //     }
  //   },
  //   async goToPage(store, payload) {
  //     if (
  //       payload.page &&
  //       store.state.ledgerExchanges.totalPages &&
  //       store.state.ledgerExchanges.totalPages >= payload.page
  //     ) {
  //       store.commit("setPage", payload.page);
  //       await store.dispatch("getLedgerExchanges");
  //     }
  //   },
  //   async changeSorting(store, payload) {
  //     if (payload.sort !== undefined) {
  //       store.commit("setSort", payload.sort);
  //       await store.dispatch("getLedgerExchanges");
  //     }
  //   },
  //   async changeLimit(store, payload) {
  //     if (payload.limit !== undefined) {
  //       store.commit("setLimit", payload.limit);
  //       await store.dispatch("getLedgerExchanges");
  //     }
  //   },
  //   changeSearchString(store, payload) {
  //     if (payload.searchString !== undefined) {
  //       store.commit("setSearchString", payload.searchString);
  //     }
  //   },
  //   changeCreator(store, payload) {
  //     if (payload.creator !== undefined) {
  //       store.commit("setCreator", payload.creator);
  //     }
  //   },
  //   async performSearch(store, payload) {
  //     store.commit("setPage", 1);
  //     await store.dispatch("getLedgerExchanges");
  //   },
  //   async resetSearch(store, payload) {
  //     store.commit("setSearchString", "");
  //     store.commit("setCreator", null);
  //     await store.dispatch("getLedgerExchanges");
  //   },
  //   async changeQueryType(store, payload) {
  //     if (
  //       payload.queryType !== undefined &&
  //       store.state.queryTemplates.map(t => t.type).includes(payload.queryType)
  //     ) {
  //       store.commit("setQueryType", payload.queryType);
  //       await store.dispatch("getLedgerExchanges");
  //     }
  //   },

  //   async addLedgerExchange(store, ledgerExchange) {
  //     try {
  //       const resp = await addLedgerExchange(ledgerExchange);
  //       return resp.data;
  //     } catch (error) {
  //       console.log(error);
  //       return false;
  //     }
  //   }
  // }
};



// WEBPACK FOOTER //
// ./src/store/modules/ledgerExchange.js